import { createConfigurationApplied, } from '@spotify-internal/event-definitions/es5/events/createConfigurationApplied';
import { createConfigurationAppliedNonAuth } from '@spotify-internal/event-definitions/es5/events/createConfigurationAppliedNonAuth';
import { KnownContext, ResolveResponse, } from '@spotify-internal/remote-config-core';
import { createExposureMiddleware } from '@spotify-internal/remote-config-exposure-common';
export const exposureMiddleware = createExposureMiddleware((options) => {
    const sender = options.eventSender;
    return ({ context, clientId, configuration, policyGroupIds, }) => {
        const authorized = Boolean(context.username);
        const eventData = createConfigAppliedEventData(clientId, context, configuration, policyGroupIds);
        if (authorized) {
            return sender.send(createConfigurationApplied(eventData));
        }
        return sender.send(createConfigurationAppliedNonAuth(eventData));
    };
});
function createConfigAppliedEventData(clientId, context, configuration, policyGroupIds) {
    const last_rcs_fetch_time = configuration.getValue(ResolveResponse.fetchTimeMillis);
    const configuration_assignment_id = configuration.getValue(ResolveResponse.configurationAssignmentId);
    return {
        platform: 'WEB',
        rc_client_id: clientId,
        configuration_assignment_id,
        fetch_type: context.fetchType,
        installation_id: context.installationId,
        last_rcs_fetch_time,
        policy_group_ids: policyGroupIds,
        identifiers: KnownContext.extractIdentifiersMap(context),
    };
}
//# sourceMappingURL=exposure.js.map